'use strict';

const $ = window.jQuery;

export default function() {
    const headerHeight = $( '#header' ).innerHeight();
    const $headerSticky = $( '#headerSticky' );
    const $menuSticky = $( '#menuSticky' );

    $( window ).scroll( function() {
        const scrollTop = $( window ).scrollTop();

        if ( scrollTop > headerHeight ) {
            $headerSticky.addClass( 'is-active' );
        } else {
            $headerSticky.removeClass( 'is-active' );
        }
    } );

    $( '#openMenuSticky, #openMobile' ).on( 'click', function() {
        $( 'body' ).addClass( 'noscroll' );
        $menuSticky.addClass( 'is-active' );
    } );

    // Close when pressing escape
    $( document ).keyup( ( e ) => {
        if ( e.key === 'Escape' ) {
            $( 'body' ).removeClass( 'noscroll' );
            $menuSticky.removeClass( 'is-active' );
        }
    } );
};
